import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import FileDropzone from './components/ui/FileDropzone.vue'
import { initTheme } from './composables/useTheme'
import { initAuth } from './composables/useAuth'
import { loadSiteData } from './composables/useSiteData'
import { initPageAnalytics } from './services/pageAnalytics'
import '@/assets/css/main.css'
import 'vue-select/dist/vue-select.css'

initTheme()

async function bootstrap() {
  initAuth()
  await loadSiteData()

  const app = createApp(App)
  app.use(router)
  initPageAnalytics(router)
  app.component('DropZone', FileDropzone)
  app.component('FileDropzone', FileDropzone)
  app.mount('#app')
}

bootstrap()
